import { UserId } from '@cibo/core'
import { useAuth } from '@cibo/profile'
import { usePrograms } from '@cibo/programs'
import { FriendlyError } from '@cibo/ui'
import { Grid, Skeleton } from '@mui/material'
import { PROGRAM_ROUTES } from 'navigation/types/routes'
import { ProgramOpportunity } from 'pages/ProgramOpportunity'
import { useTranslation } from 'react-i18next'
import { Link, generatePath } from 'react-router-dom'

interface AvailableProgramsProps {
  userId?: UserId
}

export const AvailablePrograms = ({ userId }: AvailableProgramsProps) => {
  const { persona } = useAuth()
  const { t } = useTranslation('AvailablePrograms')
  const { data: programs, isLoading, isError } = usePrograms({
    sort: [
      { sort: 'desc', field: 'enrollmentStatus' },
      { sort: 'desc', field: 'closeDate' },
    ],
  })

  if (isLoading || !persona) {
    return <Skeleton variant="rounded" height={200} />
  }

  if (isError) {
    return <FriendlyError message={t('errorLoading')} />
  }

  return (
    <Grid columns={{ xs: 4, md: 8, lg: 12 }} spacing={3} container>
      {programs?.map(({ programId }) => (
        <Grid key={programId} xs={4} item>
          <ProgramOpportunity
            userId={userId}
            programId={programId}
            LinkComponent={Link}
            to={generatePath(PROGRAM_ROUTES.DETAIL, { programId })}
            sx={{ flex: 1, height: '100%' }}
          />
        </Grid>
      ))}
    </Grid>
  )
}
